import { createTheme } from '@mui/material/styles';
import blue from '@mui/material/colors/blue';
import deepPurple from '@mui/material/colors/deepPurple';

// component overrides
import bottomNavigationAction from './components/bottomNavigationAction';
import button from './components/button';
import chip from './components/chip';
import dialogAction from './components/dialogAction';
import fab from './components/fab';
import menu from './components/menu';
import radio from './components/radio';
import select from './components/select';
import speedDial from './components/speedDial';
import switchComp from './components/switch';
import tabs from './components/tabs';
import textfields from './components/textfields';
import tooltip from './components/tooltip';

export function initTheme(themeJson, themeName) {

    return createTheme({
        // Inject the default theme palette etc from the supplied theme json
        ...themeJson,

        typography: {
            fontFamily: "'Open Sans', 'sans-serif'"
        },
        themeName: themeName,

        // Apply component overrides based on the theme palette
        components: {
            ...(bottomNavigationAction(themeJson)),
            ...(button(themeJson)),
            ...(chip(themeJson)),
            ...(dialogAction(themeJson)),
            ...(fab(themeJson)),
            ...(menu(themeJson)),
            ...(radio(themeJson)),
            ...(select(themeJson)),
            ...(speedDial(themeJson)),
            ...(switchComp(themeJson)),
            ...(tabs(themeJson)),
            ...(textfields(themeJson)),
            ...(tooltip(themeJson)),
        }
    });
}

export const defaultTheme = () => createTheme({
    palette: {
        primary: deepPurple,
        secondary: blue,
        header: deepPurple,
        background: {
            default: '#fff',
            paper: '#fff',
            surface: '#fff',
            backgroundImage: '/background.jpg'
        },
        common: {
            black: "#000",
            white: "#fff",
            border: "gainsboro"
        },
        text: {
            primary: "#00313B",
            secondary: "#007193",
            tertiary: "#00A19D",
            disabled: "rgba(129, 131, 134, 1)",
            hint: "rgba(0, 0, 0, 0.38)"
        }
    }
});